import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftvisioComponent } from './simple-icons-microsoftvisio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftvisioComponent ],
    exports:      [ SimpleIconsMicrosoftvisioComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftvisioModule {}
